/* eslint-disable no-var */
var evs = require('@rexxars/eventsource-polyfill')

module.exports = window.EventSource || evs.EventSource



// WEBPACK FOOTER //
// ../node_modules/@sanity/eventsource/browser.js